import { Descriptions, Skeleton } from 'antd'
import { CSSProperties, FC, memo, ReactNode } from 'react'

export type DescriptionItem = readonly [
  label: string,
  value: ReactNode,
  extra?: ReadonlyArray<ReactNode>,
]

const labelStyle: CSSProperties = { width: '20%' }
const contentStyle: CSSProperties = { width: '80%' }

const RawOptionalDescriptions: FC<{
  items: ReadonlyArray<DescriptionItem>
  isLoading: boolean
}> = ({ items, isLoading }) => {
  return (
    <Descriptions
      column={1}
      bordered
      styles={{
        content: contentStyle,
        label: labelStyle,
      }}>
      {items.map(([label, value, extra]) => (
        <Descriptions.Item key={label} label={label}>
          {isLoading ? (
            <Skeleton.Input active size='small' style={{ width: 200 }} />
          ) : (
            <>
              {value}
              {extra}
            </>
          )}
        </Descriptions.Item>
      ))}
    </Descriptions>
  )
}

export const OptionalDescriptions = memo(RawOptionalDescriptions)
